import React, { forwardRef } from 'react';
import styles from './FormTextArea.module.css';

const FormTextArea = forwardRef(({
    label,
    name,
    value,
    onChange,
    error,
    required = false,
    placeholder,
    disabled = false,
    rows = 4,
    maxLength,
    className = '',
    style = {},
    ...props
}, ref) => {
    const textareaId = `textarea-${name}`;

    return (
        <div className={`${styles.container} ${className}`} style={style}>
            {label && (
                <label htmlFor={textareaId} className={styles.label}>
                    {label}
                    {required && <span className={styles.required}>*</span>}
                </label>
            )}

            <div className={styles.wrapper}>
                <textarea
                    ref={ref}
                    id={textareaId}
                    name={name}
                    value={value}
                    onChange={onChange}
                    placeholder={placeholder}
                    disabled={disabled}
                    required={required}
                    rows={rows}
                    maxLength={maxLength}
                    className={`${styles.textarea} ${error ? styles.hasError : ''}`}
                    {...props}
                />

                {maxLength && (
                    <div className={styles.charCount}>
                        {value?.length || 0} / {maxLength}
                    </div>
                )}
            </div>

            {error && (
                <div className={styles.error} role="alert">
                    {error}
                </div>
            )}
        </div>
    );
});

FormTextArea.displayName = 'FormTextArea';

export { FormTextArea };
export default FormTextArea;
